import { getData } from '@umu/umu-util';
import umuWebview from '@umu/umu-webview';
import { canReportService } from '@umu/umu-api';
import { isAndroid, isUMUWebview } from '@umu/umu-ua';

type ReportParams = {
    id: string;
    url: string;
    kind?: string;
    user_id?: string;
    obj_id: string;
    category?: string;
    obj_type: string;
    target_id?: string;
};

const reportType: { [key: string]: string } = {
    ELEMENT: 'element',
    SESSION: 'element',
    COURSE: 'course',
    COMMENT: 'comment',
    PROFILE: 'profile',
};

export const callNativeReportCourseFunc = async (
    params: {
        id: string;
        url: string;
        kind: string;
        category: string;
    },
    sendType?: number,
) => {
    sendType = sendType || 2024;
    umuWebview.callHandler('sendMsgToApp', {
        type: sendType,
        data: {
            id: params.id,
            url: params.url,
            kind: params.kind || 'content',
            category: params.category || 'SESSION',
        },
    });
};

export const callNativeBlockCourseFunc = async (params: { id: string; type: string }) => {
    umuWebview.callHandler('sendMsgToApp', {
        type: 2025,
        data: {
            id: params.id,
            type: params.type,
        },
    });
};

export const canReport = async (params: ReportParams): Promise<boolean> => {
    try {
        const isEnterpriseUser = !!getData('data.user_info.enterprise_info.enterprise_id', (window as any).pageData);
        if (isEnterpriseUser || !isAndroid || !isUMUWebview) {
            return false;
        }

        const result = await canReportService({
            obj_id: params.obj_id ? params.obj_id : '1234',
            obj_type: params.obj_type,
        });
        const isCanReportResp = result ? result.data : 0;
        const isCanReport = Number(isCanReportResp) === 1;
        const category = params.category || 'SESSION';
        const type = reportType[category];

        if (isCanReport) {
            callNativeReportCourseFunc(
                {
                    category,
                    id: params.id,
                    url: params.url,
                    kind: params.kind || 'content',
                },
                2014,
            );
            callNativeBlockCourseFunc({ type, id: params.id });
        }
        return isCanReport;
    } catch (_error) {
        return false;
    }
};
